import reportError from '@shared/reportError';
import { createStore, del, get, set } from 'idb-keyval';

const itemName = 'state';
let fallbackToLocalStorage = false;

const appStore = (() => {
  try {
    return createStore('mobile-store', 'mobile');
  } catch (ex) {
    reportError(ex as Error, { cause: 'Could not instantiate IndexedDb store.' });
    fallbackToLocalStorage = true;
    return null;
  }
})();

export const loadState = async () => {
  if (!fallbackToLocalStorage) {
    try {
      return await get(itemName, appStore!);
    } catch (ex) {
      reportError(ex as Error, { level: 'warning', reason: 'Falling back to using localStorage' });
      fallbackToLocalStorage = true;
    }
  }
  try {
    return JSON.parse(localStorage.getItem(itemName) || 'null');
  } catch (ex) {
    reportError(ex as Error, { cause: 'Store data deserialization failed' });
    return null;
  }
};

export const saveState = async (state: any) => {
  try {
    if (fallbackToLocalStorage) {
      return localStorage.setItem(itemName, JSON.stringify(state));
    }
    return await set(itemName, state, appStore!);
  } catch (ex) {
    reportError(ex as Error);
  }
};

export const clearState = async () => {
  try {
    if (fallbackToLocalStorage) {
      return localStorage.removeItem(itemName);
    }
    return await del(itemName, appStore!);
  } catch (ex) {
    reportError(ex as Error);
  }
};
